import notFoundRoute from '@scoring-web/modules/main/views/404/404.route';
import mainRoute from '@scoring-web/modules/main/views/main/main.route';
import uiPlaygroundRoute from '@scoring-web/modules/main/views/ui-playground/ui-playground.route';
import { createBrowserRouter } from 'react-router';
import envConfig from '../env/env.config';

export const routes = [uiPlaygroundRoute, mainRoute, notFoundRoute];

const routeConfig = createBrowserRouter(routes, { basename: envConfig.baseUrl });

export default routeConfig;
